import React, { Component } from 'react';
import jwt_decode from 'jwt-decode'
import {
  AppSidebarNav,
} from '@coreui/react';



class Mynav extends Component {

  constructor(props) {
    super(props)
    this.state= {
      items: ''
    }

    
  }

  componentDidMount() {
    
    var items = [  
      {
        title: true,
        name: 'Quizz',
        wrapper: {
          element: '',
          attributes: {},
        },
      },
      
      {
        name: 'Créer un quizz',
        url: '/quizz/add',
        icon: 'icon-pencil',
      },
      {
        name: 'Liste des Quizz',
        url: '/quizz/list',
        icon: 'icon-list',
      },
      
    ]
    if(localStorage.jwtToken) {
      const decoded = jwt_decode(localStorage.jwtToken)
    
      console.log('decoded',decoded)
      if(decoded.role == "ROLE_SUPER_ADMIN") {
        items = [      
          {
            title: true,
            name: 'Contributeurs',
            wrapper: {            // optional wrapper object
              element: '',        // required valid HTML5 element tag
              attributes: {}        // optional valid JS object with JS API naming ex: { className: "my-class", style: { fontFamily: "Verdana" }, id: "my-id"}
            },
            class: ''             // optional class names space delimited list for title item ex: "text-center"
          },
          {
            name: 'Créer un contributeur',
            url: '/contributors/add',
            icon: 'icon-user',
          },
          {
            name: 'Liste des contributeurs',
            url: '/contributors/list',
            icon: 'icon-list',
          },
          {
            title: true,
            name: 'Quizz',
            wrapper: {
              element: '',
              attributes: {},
            },
          },
          
          {
            name: 'Créer un quizz',
            url: '/quizz/add',
            icon: 'icon-pencil',
          },
          {
            name: 'Liste des Quizz',
            url: '/quizz/list',
            icon: 'icon-list',
          },
          
        ]
        
        
      }
    }
    this.setState({
      items
    })
  }
  componentWillReceiveProps() {
    console.log('this.props',this.props)
    
  }
  
  render() {
    
    if(this.state.items != '') {
      console.log('this.state.items',this.state.items)
      return (<AppSidebarNav navConfig={{items: this.state.items}} {...this.props} />)
    }
    else {
      return (<div>chargement...</div>)
    }
    
  }
}

export default Mynav



// WEBPACK FOOTER //
// ./src/_nav.js